import dayjs from 'dayjs';
import { Box, Typography } from '@mui/material';
import { CRMCalendarStatusColor, CRMEventTypeList } from '../../config/CRMEventType';
import colorFinder from '../../utils/colorFinder';
import { sxConfig } from './CalendarView.style';
import useParam from '../../context/ParamContext';
import { useEffect, useState } from 'react';

const EventContent = ({ eventInfo }) => {
  const { params } = useParam();
  const [chipConfig, setChipConfig] = useState([]);

  const data = eventInfo.event.extendedProps.data;
  const status = eventInfo.event.extendedProps.crmCalendarStatus;
  const statusColor = CRMCalendarStatusColor.find((item) => item.value === status)?.color;

  const color = colorFinder(statusColor);
  const textColor = color.textColor || '#000';

  const findedCrmEventType = CRMEventTypeList.find((item) => item.value === data.eventType);

  let timeText = eventInfo.timeText;
  if (eventInfo.event.start) {
    timeText = dayjs(eventInfo.event.start).format('HH:mm');
  }

  useEffect(() => {
    const raw = params.CRM_CALENDAR_EVENT_CONTENT;

    if (!raw) {
      setChipConfig([]);
      return;
    }

    const parsed = JSON.parse(raw);

    setChipConfig(Array.isArray(parsed) ? parsed : []);
  }, [params]);

  const getFieldValue = (obj, path) => {
    return path.split('.').reduce((acc, part) => {
      if (Array.isArray(acc)) {
        return acc.map((item) => item?.[part]);
      }
      return acc ? acc?.[part] : null;
    }, obj);
  };

  const renderDynamicContent = () => {
    if (!chipConfig.length) return null;

    return (
      <span className="truncate block">
        {chipConfig.map((item, index) => {
          const value = getFieldValue(data, item.label);

          const displayValue = Array.isArray(value) ? value.join(', ') : value ?? 'n.a.';

          return (
            <span key={index}>
              {index > 0 && ' / '}
              {displayValue}
            </span>
          );
        })}
      </span>
    );
  };

  return (
    <Box
      sx={{
        ...sxConfig.eventBox,
        backgroundColor: color.colorBgCode,
        borderLeft: `4px solid ${color.contactMapBorder}`,
      }}
    >
      <Typography variant="caption" component="span" sx={{ ...sxConfig.eventTime, color: textColor }}>
        {timeText}
      </Typography>

      <Box component="span" sx={sxConfig.eventIconBox}>
        {findedCrmEventType?.icon || null}
      </Box>

      <Typography variant="body2" component="span" sx={{ ...sxConfig.eventTitle, color: textColor }}>
        {renderDynamicContent()}
      </Typography>
    </Box>
  );
};

export default EventContent;
